import { CircularProgress } from '@mui/material';
import React from 'react';

export const Loading = () => {
    return (  
      <CircularProgress color="primary" />
    );
}
